import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { ShortLinksService } from "../../../../auth/service/short-links.service";
import { environment } from "../../../../../environments/environment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-detail-short-link",
  templateUrl: "./detail-short-link.component.html",
  styleUrls: ["./detail-short-link.component.scss"],
})
export class DetailShortLinkComponent implements OnInit {
  public idShortlink: string;

  public shortlink: any;

  public contentHeader: IContentHeader;

  public environment: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    public _shortLinkService: ShortLinksService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private _routerService: Router,
  ) {
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      this.idShortlink = params.get("id");
    });
    if (this.idShortlink) {
      this.contentHeader = {
        headerTitle: this.idShortlink,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: "MENU.SHORTLINKS",
              isLink: true,
              link: "/dashboard/short-links",
            },
            {
              name: "DETAIL_SINGULAR",
              isLink: false,
            },
          ],
        },
      };
    }
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_shortlink_detail")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._shortLinkService.getShortLink(this.idShortlink).then((result: any) => {
      this.shortlink = result;
    });
    this.environment = environment.SHORTLINK_URL;
  }
}
